<script>

import EmployerForm from "@/components/users/EmployerForm.vue";

export default {
    components: {EmployerForm},
}

</script>
<template>
    <div class="trainings-create">

        <employer-form :user="{company: {}}"/>

    </div>
</template>
